(function () {
  // VARIABLES
  const annoucementObj = [
    {
      type: "desktop",
      wrapper: getWrapper(".section-header"),
      elements: getElements(getWrapper(".section-header")),
    },
    // {
    //   type: "mobile",
    //   wrapper: getWrapper(".header"),
    //   elements: getElements(getWrapper(".header")),
    // },
  ];

  const total = getElements(getWrapper(".section-header")).length;

  let slider = 0;
  let currentSlider;

  // FUNCTIONS
  function getWrapper(parent) {
    return document.querySelector(`${parent} .announcement-bar-wrapper`);
  }

  function getElements(wrapper) {
    return wrapper.querySelectorAll(".announcement-bar");
  }

  function slide(wrapper, elements, total) {
    // Change order
    for (const [i, el] of elements.entries()) {
      el.style.order =
        el.style.order == 0 ? `${total - 1}` : parseInt(el.style.order) - 1;
    }

    // Scroll element
    wrapper.scrollBy({
      left: window.innerWidth,
      behavior: "smooth",
    });

    // Set new timeout
    slider = setTimeout(() => {
      slide(wrapper, elements, total);
    }, 2000);
  }

  function startSlide() {
    // let obj;

    // if (window.innerWidth >= 990 && currentSlider != "desktop") {
    //   obj = annoucementObj.filter((x) => x.type == "desktop")[0];
    // } else if (window.innerWidth < 990 && currentSlider != "mobile") {
    //   obj = annoucementObj.filter((x) => x.type == "mobile")[0];
    // }

    let obj = annoucementObj.filter((x) => x.type == "desktop")[0];

    if (obj) {
      clearTimeout(slider);
      currentSlider = obj.type;
      slide(obj.wrapper, obj.elements, total);
    }
  }

  // window.addEventListener("resize", function (event) {
  //   startSlide();
  // });
  startSlide();
})();
